module.exports = __webpack_public_path__ + "img/error-page.27039908.png";